import * as React from 'react';
export const IcArtificialInsemination = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 2H6a1 1 0 000 2h1v13a5 5 0 1010 0V4h1a1 1 0 100-2zm-5.36 9.23A3.08 3.08 0 0114 13.67a2.68 2.68 0 01-.7 1.82A2 2 0 1110 17a3 3 0 011.36-2.43c.51-.43.64-.58.64-.9 0-.32-.16-.5-.64-.9A3 3 0 0110 10.33a3 3 0 011.36-2.43c.48-.4.64-.56.64-.9a1 1 0 012 0 3.08 3.08 0 01-1.36 2.44c-.48.4-.64.56-.64.89 0 .33.16.5.64.9z'
      fill='currentColor'
    />
  </svg>
);
